import { EXISTING_ACCOUNTS } from "../Data/existingAccounts";
import { getPhoneCountryOption } from "./phoneCountryOptions";
import {
  normalizeAccountNumber,
  normalizeEmail,
  normalizePhoneDigits,
  validateAccountNumber,
  validateRecoveryEmail,
  validateRecoveryPhone,
} from "./signupValidation";

export const phonesMatch = (storedPhone, localPhone, countryCode) => {
  const stored = normalizePhoneDigits(storedPhone);
  const local = normalizePhoneDigits(localPhone).replace(/^0+/, "");
  if (!stored || local.length < 7) return false;

  const dial = getPhoneCountryOption(countryCode)?.dialCode || "";
  const combined = `${normalizePhoneDigits(dial)}${local}`;
  return stored === combined || stored.endsWith(local);
};

const toLookupResult = (account) => {
  if (!account.kycApproved) {
    return {
      status: "pending",
      account,
      error: "signup.kycPending",
    };
  }

  return { status: "approved", account };
};

export const lookupKycStatus = (accountNumber) => {
  const validationError = validateAccountNumber(accountNumber);
  if (validationError) {
    return { status: "invalid", error: validationError };
  }

  const account = EXISTING_ACCOUNTS.find(
    (item) => item.accountNumber === normalizeAccountNumber(accountNumber)
  );

  if (!account) {
    return {
      status: "not_found",
      error: "signup.kycNotFound",
    };
  }

  return toLookupResult(account);
};

export const lookupAccountByContact = ({
  method = "email",
  email = "",
  phone = "",
  phoneCountryCode = "",
} = {}) => {
  if (method === "phone") {
    const validationError = validateRecoveryPhone(phone);
    if (validationError) {
      return { status: "invalid", field: "phone", error: validationError };
    }

    const account = EXISTING_ACCOUNTS.find((item) =>
      phonesMatch(item.phone, phone, phoneCountryCode)
    );

    if (!account) {
      return { status: "not_found", error: "signup.recoverNotFound" };
    }

    return toLookupResult(account);
  }

  const validationError = validateRecoveryEmail(email);
  if (validationError) {
    return { status: "invalid", field: "email", error: validationError };
  }

  const account = EXISTING_ACCOUNTS.find(
    (item) => normalizeEmail(item.email) === normalizeEmail(email)
  );

  if (!account) {
    return { status: "not_found", error: "signup.recoverNotFound" };
  }

  return toLookupResult(account);
};
